var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tfb-text-standard-smaller",attrs:{"id":"recaptcha_container"}},[_vm._v(" This site is protected by reCAPTCHA. ")])
}
var staticRenderFns = []

export { render, staticRenderFns }